export const searchUser2 = () => {
  // 検索ボタン
  const searchButton = document.getElementById( 'js-search-button' );

  // テーブル
  // const searchHide   = document.getElementById( 'js-hide' );
  // searchHide.style.display = 'none';

  // 担当ユーザーID
  const userButtons  = document.querySelectorAll( '.p-search-table__item .user' );

  // モーダルウィンドウ
  const modalUser        = document.querySelector( '.js-modal-user' );

  searchButton.addEventListener( 'click', () => {
    // searchHide.style.display = 'block';
  } );

  userButtons.forEach( item => {
    item.addEventListener( 'click', () => {
      modalUser.classList.add( 'is--show' );
    } );
  } );

  modalUser.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalUser.classList.remove( 'is--show' );
  } );

  /**
   * 戻るボタン
   */
  // const buttonPrevRegistInput = document.getElementById( 'js-modal-regist-input-prev' );
  // buttonPrevRegistInput.addEventListener( 'click', () => {
  //   modalRegist.classList.remove( 'is--show' );
  // } );
}
